// URL des fiches bornes — paramétrable.
//
// Tant que l'app Bornes n'est pas en ligne, les liens pointent vers le CRM.
// Deux niveaux, du plus prioritaire au moins prioritaire :
//   1. le réglage `integrations.bornes_url` (page Paramètres) ;
//   2. la variable d'environnement REACT_APP_BORNES_URL_TEMPLATE ;
//   3. à défaut, le CRM de production (surchargeable par environnement).
//
// Le gabarit accepte {id} (identifiant technique) et {numero} (ex. C128).

import { getSetting } from '../services/api';

const DEFAUT = 'https://crm.konitys.fr/fr/bornes/view/{id}';

let gabarit = process.env.REACT_APP_BORNES_URL_TEMPLATE || DEFAUT;
let charge = null;

/** Charge le réglage une seule fois par session (silencieux si indisponible). */
export function loadBorneUrlTemplate() {
  if (charge) return charge;
  charge = getSetting('integrations.bornes_url')
    .then((v) => {
      const t = typeof v === 'string' ? v.trim() : v?.template?.trim();
      if (t) gabarit = t;
      return gabarit;
    })
    .catch(() => gabarit);
  return charge;
}

export const getBorneUrlTemplate = () => gabarit;

/**
 * URL de la fiche d'une borne. Renvoie null si le gabarit ne peut pas être
 * rempli : mieux vaut un numéro non cliquable qu'un lien cassé.
 */
export function borneUrl(borne) {
  if (!borne || !gabarit) return null;
  const id = borne.id ?? borne.borne_id ?? borne.id_borne ?? null;
  const numero = borne.numero_formated ?? borne.numero ?? null;
  if (gabarit.includes('{id}') && (id === null || id === undefined || id === '')) return null;
  if (gabarit.includes('{numero}') && !numero) return null;
  return gabarit
    .replace('{id}', encodeURIComponent(id ?? ''))
    .replace('{numero}', encodeURIComponent(numero ?? ''));
}
